import { firebase } from './api/firebase'

let db = firebase.firestore()
db.settings({timestampsInSnapshots: true})

export const itemFilters = {
  state: {
    displayFilterMenu: true,
    showMarketPlaceFilters: false,
    toolbarFilterText: 'Filtering By ',
    collections: [],
    styles: {},
    styleNameMap: {},
    selectedGroupId: null,
    selectedFabric: null,
    selectedColorGroups: null,
    selectedCollection: null,
    selectedSize: null,
    selectedStyle: null,
    fetchError: null,
    detachCollection: null,
    detachStyles: null,
    // fabricOptions: ['solid', 'pattern'],
    // colorGroupOptions: ['GraysAndBlack', 'Whites', 'Blues', 'Browns', 'Cyans', 'Greens', 'Oranges', 'Pinks', 'Purples', 'Reds', 'Yellows']
    fabric: {
      colorGroups: ['Pinks', 'Reds', 'Oranges', 'Yellows', 'Browns', 'Greens', 'Cyans', 'Blues', 'Purples', 'Whites', 'GraysAndBlack'].sort(),
      types: ['stretchy', 'not stretchy', 'medium stretch', 'ribbed', 'cotton blend', 'polly blend', 'rayon blend', 'slinky / ITY', 'liverpool', 'jacquard', 'chiffon', 'lace', 'leggings material', 'modal', 'lightweight', 'embossed', 'sheer', 'crinkle'].sort(),
      prints: ['solid', 'heathered', 'ringer', 'floral', 'stripe', 'microstripe', 'pattern', 'dipped', 'houndstooth', 'animal', 'paisley', 'aztec', 'geometric', 'dipped', 'color block'].sort()
    }
  },
  getters: {
    //   TODO: We need getters for styles and sizes since they are computed from
    // collection and sizes computed from collection and style
    getStyles: state => {
      if (state.selectedCollection && state.styles !== {} && state.styles[state.selectedCollection]) {
        return state.styles[state.selectedCollection]
      } else {
        return []
      }
    },
    getSizes: state => {
      if (state.selectedStyle) {
        return state.styles[state.selectedCollection][state.selectedStyle].sizes
      } else {
        return []
      }
    }
  },
  mutations: {
    setFilterDisplayMenu: (state, payload) => {
      state.displayFilterMenu = payload
    },
    setCollections: (state, payload) => {
      state.collections = payload
    },
    setSelectedCollection: (state, payload) => {
      state.selectedCollection = payload
    },
    setStyles: (state, payload) => {
      state.styles = payload
    },
    setSelectedStyle: (state, payload) => {
      state.selectedStyle = payload
    },
    setSizes: (state, payload) => {
      state.sizes = payload
    },
    setSelectedSize: (state, payload) => {
      state.selectedSize = payload
    },
    setFetchError: (state, payload) => {
      state.fetchError = payload
    },
    setStyleNameMap: (state, payload) => {
      state.styleNameMap = payload
    },
    detachCollection: (state, payload) => {
      state.detachCollection = payload
    },
    detachStyles: (state, payload) => {
      state.detachStyles = payload
    },
    setToolbarFilterText: (state, payload) => {
      state.toolbarFilterText = payload
    },
    setMarketplaceFilters: (state, payload) => {
      state.showMarketPlaceFilters = payload
    },
    setSelectedFabric: (state, payload) => {
      state.selectedFabric = payload
    },
    setSelectedColorGroups: (state, payload) => {
      state.selectedColorGroups = payload
    }
  },
  actions: {
    addMarketplaceFilters: context => {
      context.commit('setMarketplaceFilters', true)
    },
    removeMarketplaceFilters: context => {
      context.commit('setMarketplaceFilters', false)
    },
    setToolbarFilterText: (context, value) => {
      context.commit('setToolbarFilterText', value)
    },
    setFilterDisplayMenu: (context, value) => {
      console.log('in actions to toggle menu')
      context.commit('setFilterDisplayMenu', value)
    },
    setSelectedFabric: (context, value) => {
      context.commit('setSelectedFabric', value)
    },
    setSelectedColorGroups: (context, value) => {
      context.commit('setSelectedColorGroups', value)
    },
    setCollection: context => {
      let unsubscribe = db.collection('collections')
        .orderBy('sort')
        .onSnapshot(qSnap => {
          let names = []
          qSnap.forEach(doc => {
            names.push(doc.id)
          })
          console.log('setting collection data...')
          context.commit('setCollections', names)
        })
      context.commit('detachCollection', unsubscribe)
    },
    setStyles: (context) => {
      let unsubscribe = db.collection('styles')
        .onSnapshot(qSnap => {
          let styles = {}
          let styleNameMap = {}
          qSnap.forEach(doc => {
            let data = doc.data()

            styleNameMap[data.filenameMap] = doc.id

            // styles{ collectionName: {styleName: { sizes [] },  }}
            // we're going to build a "map" so that styles are keys with
            // size, MAP, and wholesale data.
            if (doc.id !== 'Outfit') {
              Object.keys(data.collections).forEach(col => {
                // console.log('col: ', col)
                styles[col] = styles[col] || {}
                styles[col][doc.id] = {
                  sizes: Object.keys(data.collections[col]).filter(key => !(/Id/).test(key))
                }
              })
            } else {
              // We've the Outfit "style" and it needs to be setup manually for every collection.
              context.state.collections.forEach(col => {
                styles[col] = styles[col] || {}
                styles[col].Outfit = {
                  sizes: ['Outfit']
                }
              })
            }
          })
          context.commit('setStyleNameMap', styleNameMap)
          context.commit('setStyles', styles)
        })
      context.commit('detachStyles', unsubscribe)
    },
    detachCollections: (context) => {
      context.state.detachCollection()
    },
    detachStyles: (context) => {
      context.state.detachStyles()
    },
    setSelectedCollection: (context, selection) => {
      context.commit('setSelectedCollection', selection)
      // when we change collections we need to reset selected style & size
      context.commit('setSelectedStyle', null)
      context.commit('setSelectedSize', null)
      // context.dispatch('setStyles', selection)
    },
    setSelectedStyle: (context, selection) => {
      context.commit('setSelectedStyle', selection)
      // when we change style, we need to reset size
      context.commit('setSelectedSize', null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/itemFilters.js